module.exports = __webpack_public_path__ + "img/FeaturesofHongKongTrustLaw1.18af944a.jpg";